import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from '../locales/de/common.json';
import ch from '../locales/ch/common.json';
import fr from '../locales/fr/common.json';
import it from '../locales/it/common.json';
import en from '../locales/en/common.json';
import es from '../locales/es/common.json';
// Restore locale from localStorage (persisted by language switcher)
const savedLocale = typeof window !== 'undefined' ? localStorage.getItem('locale') : null;

// i18n configuration — Swiss official languages + Schweizerdeutsch + English
i18n.use(initReactI18next).init({
  resources: {
    de: { translation: de },
    ch: { translation: ch },
    fr: { translation: fr },
    it: { translation: it },
    en: { translation: en },
    es: { translation: es },
  },
  lng: savedLocale || 'de',
  fallbackLng: 'de',
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

export default i18n;
